export default "__VITE_ASSET__UAr2uKNF__"